import Content from '../../../../components/Content';

import logo from '../../../../assets/img/sheep-orange.jpeg';

import { Container, GradientBackground } from './styles';

const Logo = () => {
  return (
    <Container>
      <Content>
        {/* <img src={logo} alt="Worsheep" style={{ width: '5rem', height: '5rem', borderRadius: '10px' }} /> */}
        <h1>Perguntas frequentes</h1>
      </Content>
      {/* <GradientBackground /> */}
    </Container>
  );
};

export default Logo;
